function handles({ domain }) {
  return domain === 'clips.twitch.tv';
}

export default handles;



// WEBPACK FOOTER //
// ./src/components/TwitchPost/handles.js